export default __webpack_public_path__ + "notebooks.763fcee4.png";